import axios from "axios";
import {$appConfig} from "../../../appConfig";

const baseURL = $appConfig.endpoint.baseUrl;
export default axios.create({
    baseURL: baseURL,
    headers: {
        "Content-type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`
    }
})
